// import React, { useState, useEffect, useCallback } from "react";
// import { Plus, Edit, Trash2, GitFork, ArrowLeft, X, User, Users, AlertCircle } from "lucide-react";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import PageLoader from "../../../helpers/PageLoader";
// import SummaryApi from "../../../common/SummaryApi";
// import api from "../../../common/apiClient";
// import SelectDropdown from "../../../customStyles/SelectDropdown";
// import DeleteConfirmationOffcanvas from "../../../helpers/DeleteConfirmationOffcanvas";

// const EVALUATOR_TYPES = [
//   { value: "SELF", label: "Self (Employee)" },
//   { value: "REPORTING_MANAGER", label: "Reporting Manager (L1)" },
//   { value: "L2_MANAGER", label: "L2 Manager (Manager's Manager)" },
//   { value: "SPECIFIC_USER", label: "Specific User" },
// ];

// const emptyForm = {
//   name: "",
//   description: "",
//   stages: [
//     { sequence: 1, stageKey: "self", stageName: "Self Assessment", evaluatorType: "SELF", specificEvaluatorId: "" }
//   ],
//   isActive: true,
// };

// // Normalize dynamic mongoose populated objects to plain string IDs to resolve the Edit mode population bug
// const normalizeWorkflowForEdit = (workflowToEdit) => {
//   if (!workflowToEdit) return emptyForm;
//   return {
//     ...workflowToEdit,
//     stages: (workflowToEdit.stages || []).map(stage => ({
//       ...stage,
//       // Extract the plain string ID from the populated user object
//       specificEvaluatorId: stage.specificEvaluatorId?._id || stage.specificEvaluatorId || ""
//     }))
//   };
// };

// const WorkflowForm = ({ workflow, onSave, onClose }) => {
//   // Use normalization helper to load existing values cleanly on edit
//   const [form, setForm] = useState(() => normalizeWorkflowForEdit(workflow));
//   const [users, setUsers] = useState([]);
//   const [saving, setSaving] = useState(false);
//   const [errors, setErrors] = useState({});

//   const fetchUsers = useCallback(async () => {
//     try {
//       const response = await api.get(SummaryApi.getAllUsers.url);
//       if (response.data.success) {
//         const activeUsers = (response.data.data || []).filter(
//           (u) => u.isActive !== false,
//         );

//         const formatted = activeUsers.map((u) => ({
//           label: `${u.firstName} ${u.lastName} (${u.customRoleId?.roleName || u.role})`,
//           value: u._id,
//         }));
//         setUsers(formatted);
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     }
//   }, []);

//   useEffect(() => {
//     fetchUsers();
//   }, [fetchUsers]);

//   const updateSequencesAndKeys = (stagesList) => {
//     return stagesList.map((stage, idx) => {
//       const sequence = idx + 1;
//       const stageKey = stage.stageName
//         ? stage.stageName.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/(^_+|_+$)/g, "")
//         : `stage_${sequence}`;

//       return {
//         ...stage,
//         sequence,
//         stageKey
//       };
//     });
//   };

//   const handleAddStage = () => {
//     const newStageList = [
//       ...form.stages,
//       { sequence: form.stages.length + 1, stageKey: "", stageName: "", evaluatorType: "REPORTING_MANAGER", specificEvaluatorId: "" }
//     ];
//     setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(newStageList) }));
//     setErrors({});
//   };

//   const handleRemoveStage = (index) => {
//     if (form.stages.length <= 1) {
//       return toast.error("At least one stage is required.");
//     }
//     const filteredList = form.stages.filter((_, idx) => idx !== index);
//     setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(filteredList) }));
//     setErrors({});
//   };

//   const handleStageChange = (index, key, val) => {
//     const updatedList = form.stages.map((stage, idx) => {
//       if (idx !== index) return stage;
      
//       const updatedStage = { ...stage, [key]: val };
      
//       if (key === "evaluatorType" && val !== "SPECIFIC_USER") {
//         updatedStage.specificEvaluatorId = "";
//       }
//       return updatedStage;
//     });

//     setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(updatedList) }));
//     setErrors({});
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!form.name.trim()) {
//       newErrors.name = "Workflow name is required.";
//     }

//     const stageErrors = [];
//     form.stages.forEach((stage, idx) => {
//       const currentStageErrors = {};
//       if (!stage.stageName.trim()) {
//         currentStageErrors.stageName = "Stage display name is required.";
//       }
//       if (stage.evaluatorType === "SPECIFIC_USER" && !stage.specificEvaluatorId) {
//         currentStageErrors.specificEvaluatorId = "Please select a specific evaluator user.";
//       }

//       if (Object.keys(currentStageErrors).length > 0) {
//         stageErrors[idx] = currentStageErrors;
//       }
//     });

//     if (stageErrors.length > 0) {
//       newErrors.stages = stageErrors;
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return toast.error("Please fill all the required fields correctly.");
//     }

//     setSaving(true);
//     try {
//       const res = workflow?._id
//         ? await api.put(SummaryApi.updateKRAReviewWorkflow.url(workflow._id), form)
//         : await api.post(SummaryApi.craeteKRAReviewWorkflow.url, form);

//       toast.success(`Workflow successfully ${workflow ? "updated" : "created"}`);
//       onSave(res.data.data);
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to process performance workflow request");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] overflow-hidden">
//       <div className="absolute inset-0 bg-black/40 transition-opacity" onClick={onClose} />
      
//       <div className="absolute inset-y-0 right-0 max-w-full flex">
//         <div className="w-screen max-w-lg bg-white shadow-2xl flex flex-col animate-slide-in">
//           <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
//             <h2 className="font-bold text-gray-800 text-lg">
//               {workflow ? "Edit Performance Workflow" : "Create Performance Workflow"}
//             </h2>
//             <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
//               <X className="w-5 h-5 text-gray-500" />
//             </button>
//           </div>

//           <form id="workflow-form" onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6 space-y-6">
//             <div>
//               <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1">
//                 Workflow Name *
//               </label>
//               <input 
//                 type="text" 
//                 value={form.name}
//                 onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
//                 placeholder="e.g., Tech Team 3-Stage Appraisal"
//                 className={`w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 ${
//                   errors.name 
//                     ? "border-red-500 focus:ring-red-200" 
//                     : "border-gray-300 focus:ring-red-300"
//                 }`}
//               />
//               {errors.name && (
//                 <p className="text-[11px] text-primary font-medium mt-1 flex items-center gap-1">
//                   <AlertCircle className="w-3 h-3" /> {errors.name}
//                 </p>
//               )}
//             </div>

//             <div>
//               <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1">
//                 Description
//               </label>
//               <textarea 
//                 value={form.description}
//                 onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
//                 placeholder="Describe who uses this workflow or process sequence"
//                 rows={2}
//                 className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-red-300 resize-none"
//               />
//             </div>

//             <div className="space-y-4">
//               <div className="flex justify-between items-center">
//                 <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">
//                   Appraisal Evaluation Stages *
//                 </label>
//                 <button 
//                   type="button" 
//                   onClick={handleAddStage}
//                   className="text-xs bg-red-50 text-primary hover:bg-red-100 px-3 py-1.5 rounded-lg font-bold border border-red-200 flex items-center gap-1 transition-colors"
//                 >
//                   <Plus className="w-3.5 h-3.5" /> Add Stage
//                 </button>
//               </div>

//               <div className="space-y-4">
//                 {form.stages.map((stage, idx) => {
//                   const stageError = errors.stages?.[idx] || {};

//                   return (
//                     <div key={idx} className="relative p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-4">
//                       <div className="flex justify-between items-center">
//                         <span className="text-xs font-bold bg-red-100 text-red-700 px-2 py-0.5 rounded-md uppercase">
//                           Stage #{stage.sequence}
//                         </span>
//                         {form.stages.length > 1 && (
//                           <button 
//                             type="button" 
//                             onClick={() => handleRemoveStage(idx)}
//                             className="text-xs text-red-500 hover:text-red-700 font-semibold"
//                           >
//                             Remove
//                           </button>
//                         )}
//                       </div>

//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//                         <div>
//                           <label className="block text-[11px] font-medium text-gray-500 mb-1">Display Name *</label>
//                           <input 
//                             type="text" 
//                             value={stage.stageName}
//                             onChange={(e) => handleStageChange(idx, "stageName", e.target.value)}
//                             placeholder="e.g., L1 Manager Review"
//                             className={`w-full border rounded-lg px-3 py-1.5 text-sm outline-none focus:ring-2 ${
//                               stageError.stageName 
//                                 ? "border-red-500 focus:ring-red-200" 
//                                 : "border-gray-300 focus:ring-red-200"
//                             }`}
//                           />
//                           {stageError.stageName && (
//                             <p className="text-[10px] text-primary font-medium mt-1 flex items-center gap-1">
//                               <AlertCircle className="w-3 h-3" /> {stageError.stageName}
//                             </p>
//                           )}
//                         </div>

//                         <div>
//                           <label className="block text-[11px] font-medium text-gray-500 mb-1">Evaluator Method *</label>
//                           <SelectDropdown 
//                             options={EVALUATOR_TYPES}
//                             value={stage.evaluatorType}
//                             onChange={(val) => handleStageChange(idx, "evaluatorType", val)}
//                             placeholder="Select evaluators"
//                             valueKey="value"
//                             labelKey="label"
//                             ChildClassName="h-[34px] border-gray-300"
//                             zIndex={66}
//                           />
//                         </div>
//                       </div>

//                       {stage.evaluatorType === "SPECIFIC_USER" && (
//                         <div className="pt-1 animate-fade-in">
//                           <label className="block text-[11px] font-medium text-gray-500 mb-1">
//                             Select Specific Evaluator User *
//                           </label>
//                           <SelectDropdown 
//                             options={users}
//                             value={stage.specificEvaluatorId}
//                             onChange={(val) => handleStageChange(idx, "specificEvaluatorId", val)}
//                             placeholder="Search and select employee..."
//                             searchable={true}
//                             valueKey="value"
//                             labelKey="label"
//                             error={!!stageError.specificEvaluatorId}
//                             zIndex={66}
//                             ChildClassName={`h-[34px] ${stageError.specificEvaluatorId ? "border-red-500" : "border-gray-300"}`}
//                           />
//                           {stageError.specificEvaluatorId && (
//                             <p className="text-[10px] text-primary font-medium mt-1 flex items-center gap-1">
//                               <AlertCircle className="w-3 h-3" /> {stageError.specificEvaluatorId}
//                             </p>
//                           )}
//                         </div>
//                       )}

//                       <div className="text-[10px] text-gray-400">
//                         Technical identifier: <span className="font-mono text-gray-600">{stage.stageKey || "auto_generated"}</span>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </div>

//             <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100">
//               <span className="text-sm font-medium text-gray-700">Workflow Active Status</span>
//               <button 
//                 type="button"
//                 onClick={() => setForm(p => ({ ...p, isActive: !p.isActive }))}
//                 className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.isActive ? "bg-primary" : "bg-gray-300"}`}
//               >
//                 <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.isActive ? "translate-x-5" : "translate-x-0"}`} />
//               </button>
//             </div>
//           </form>

//           <div className="p-6 border-t bg-gray-50 flex gap-3">
//             <button type="button" onClick={onClose} className="flex-1 bg-white border border-gray-300 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors">
//               Cancel
//             </button>
//             <button type="submit" form="workflow-form" disabled={saving}
//               className="flex-1 bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-50 shadow-lg shadow-red-100"
//             >
//               {saving ? "Saving…" : (workflow ? "Update Workflow" : "Create Workflow")}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default function KRAReviewWorkflowManagement() {
//   const navigate = useNavigate();
//   const [workflows, setWorkflows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [formState, setFormState] = useState({ open: false, workflow: null });
//   const [deleteState, setDeleteState] = useState({ open: false, id: null, name: "" });

//   const loadWorkflows = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(SummaryApi.getAllKRAReviewWorkflows.url);
//       setWorkflows(res.data.data || []);
//     } catch {
//       toast.error("Failed to load appraisal workflows");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadWorkflows();
//   }, [loadWorkflows]);

//   const handleSave = (saved) => {
//     setWorkflows(prev => 
//       prev.find(w => w._id === saved._id)
//         ? prev.map(w => (w._id === saved._id ? saved : w))
//         : [saved, ...prev]
//     );
//     setFormState({ open: false, workflow: null });
//   };

//   const handleDeleteConfirm = async () => {
//     try {
//       await api.delete(SummaryApi.deleteKRAReviewWorkflow.url(deleteState.id));
//       setWorkflows(prev => prev.filter(w => w._id !== deleteState.id));
//       toast.success("Workflow removed successfully");
//       setDeleteState({ open: false, id: null, name: "" });
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to delete workflow config");
//     }
//   };

//   const getEvaluatorLabel = (stage) => {
//     if (stage.evaluatorType === "SELF") return "Self Appraisal";
//     if (stage.evaluatorType === "REPORTING_MANAGER") return "Reporting Manager (L1)";
//     if (stage.evaluatorType === "L2_MANAGER") return "L2 Manager (Manager's Manager)";
//     if (stage.evaluatorType === "SPECIFIC_USER" && stage.specificEvaluatorId) {
//       const user = stage.specificEvaluatorId;
//       const roleName = user.customRoleId?.roleName || user.role || "Employee";
//       return `${user.firstName} ${user.lastName} (${roleName})`;
//     }
//     return "Not Configured";
//   };

//   // Image 1 style: color palette map based on index positions
//   const getThemeColors = (index) => {
//     const themes = [
//       { border: "border-[#fbc531]", text: "text-[#fbc531]", bg: "bg-[#fbc531]/5" }, // Yellow
//       { border: "border-[#fa8231]", text: "text-[#fa8231]", bg: "bg-[#fa8231]/5" }, // Orange
//       { border: "border-[#ef57b2]", text: "text-[#ef57b2]", bg: "bg-[#ef57b2]/5" }, // Pink
//       { border: "border-[#2bcbba]", text: "text-[#2bcbba]", bg: "bg-[#2bcbba]/5" }, // Teal
//       { border: "border-[#a55eea]", text: "text-[#a55eea]", bg: "bg-[#a55eea]/5" }  // Purple
//     ];
//     return themes[index % themes.length];
//   };

//   return (
//     <div className="p-4">
//       <div className="mb-6 flex flex-row justify-between items-center gap-2">
//         <div className="flex items-center gap-3">
//           <button onClick={() => navigate(-1)} className="rounded-lg bg-red-50 border border-red-100 hover:border-red-500 text-primary p-2 transition-colors">
//             <ArrowLeft className="w-5 h-5" />
//           </button>
//           <div className="flex items-center gap-2">
//             <div className="p-1.5 bg-red-100 rounded-lg hidden xs:block">
//               <GitFork className="w-5 h-5 text-primary" />
//             </div>
//             <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap tracking-tight">
//               Appraisal Workflows
//             </h1>
//           </div>
//         </div>
//         <button 
//           onClick={() => setFormState({ open: true, workflow: null })}
//           className="flex items-center gap-2 bg--primary text-white p-2.5 sm:px-4 sm:py-2 rounded-lg hover:shadow-lg transition-all flex-shrink-0"
//         >
//           <Plus className="w-5 h-5" /> 
//           <span className="hidden sm:block text-sm font-semibold">Add Workflow</span>
//         </button>
//       </div>

//       {loading ? (
//         <PageLoader />
//       ) : workflows.length === 0 ? (
//         <div className="text-center py-20 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
//           <GitFork className="w-16 h-16 mx-auto mb-4 text-gray-300" />
//           <p className="text-gray-500 font-medium">No performance appraisal workflows configured yet.</p>
//           <button 
//             onClick={() => setFormState({ open: true, workflow: null })} 
//             className="mt-4 text-primary font-bold hover:underline"
//           >
//             Create your first workflow
//           </button>
//         </div>
//       ) : (
//         <div className="space-y-6">
//           {workflows.map((flow) => (
//             <div 
//               key={flow._id} 
//               className="bg-white border border-gray-100 shadow-sm rounded-xl p-6 hover:shadow-md transition-all flex flex-col gap-6"
//             >
//               {/* Card Top: Details and Actions */}
//               <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-gray-100 pb-4">
//                 <div>
//                   <div className="flex items-center gap-2.5 mb-1.5">
//                     <span className="font-bold text-gray-900 text-base leading-tight">{flow.name}</span>
//                     <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${
//                       flow.isActive 
//                         ? "bg-green-50 text-green-700 border border-green-200" 
//                         : "bg-gray-100 text-gray-500 border border-gray-200"
//                     }`}>
//                       {flow.isActive ? "Active" : "Inactive"}
//                     </span>
//                   </div>
//                   <p className="text-xs text-gray-500 leading-relaxed max-w-2xl">
//                     {flow.description || "No description provided."}
//                   </p>
//                 </div>
                
//                 <div className="flex gap-2 self-end sm:self-auto shrink-0">
//                   <button 
//                     onClick={() => setFormState({ open: true, workflow: flow })}
//                     className="p-2 text-gray-400 hover:text-primary hover:bg-red-50 rounded-lg transition-all"
//                   >
//                     <Edit className="w-4 h-4" />
//                   </button>
//                   <button 
//                     onClick={() => setDeleteState({ open: true, id: flow._id, name: flow.name })}
//                     className="p-2 text-gray-400 hover:text-primary hover:bg-red-50 rounded-lg transition-all"
//                   >
//                     <Trash2 className="w-4 h-4" />
//                   </button>
//                 </div>
//               </div>

//               {/* Card Bottom: Horizontal Flow Chart matching Image 1 with Mobile Scroll */}
//               <div className="w-full overflow-x-auto py-4 px-1 custom-scrollbar">
//                 <div className="flex items-center min-w-max pr-6">
//                   {flow.stages.map((stage, sIdx) => {
//                     const colors = getThemeColors(sIdx);
                    
//                     return (
//                       <React.Fragment key={sIdx}>
//                         {/* Step Card matching Image 1 container frame structure */}
//                         <div className={`w-[220px] rounded-[12px] border-2 ${colors.border} ${colors.bg} p-5 relative flex flex-col justify-between items-center text-center shrink-0 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md`}>
                          
//                           {/* Inner Label Container */}
//                           <div className="w-full">
//                             <h4 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
//                               Stage {stage.sequence}
//                             </h4>
//                             <p className="text-sm font-extrabold text-gray-800 leading-snug px-1 truncate">
//                               {stage.stageName}
//                             </p>
//                           </div>

//                           {/* Decorative Horizontal/Branching Divider Line inside Node */}
//                           <div className="w-4/5 my-4 border-t border-gray-200 flex justify-center items-center">
//                             <span className="bg-white border-2 border-gray-300 rounded-full p-1.5 -mt-3.5 shadow-sm text-gray-500">
//                               {stage.evaluatorType === "SELF" ? (
//                                 <User className="w-3.5 h-3.5" />
//                               ) : (
//                                 <Users className="w-3.5 h-3.5" />
//                               )}
//                             </span>
//                           </div>

//                           {/* Dynamic Evaluator Assignment Metadata Text block */}
//                           <div className="w-full">
//                             <p className="text-xs font-semibold text-gray-600 px-1 truncate">
//                               {getEvaluatorLabel(stage)}
//                             </p>
//                             <p className="text-[10px] text-gray-400 font-mono mt-1 tracking-wider uppercase">
//                               {stage.evaluatorType.replace(/_/g, " ")}
//                             </p>
//                           </div>
//                         </div>

//                         {/* Connecting Line Nodes with inner circles matching Image 1 */}
//                         {sIdx < flow.stages.length - 1 && (
//                           <div className="flex items-center shrink-0">
//                             {/* Horizontal Left Line segment */}
//                             <div className="w-6 h-0.5 bg-gray-300" />
                            
//                             {/* Inner Circle Node Connector */}
//                             <div className="w-4 h-4 rounded-full border-2 border-gray-300 bg-white shadow-sm flex items-center justify-center shrink-0 relative z-10">
//                               <div className="w-1.5 h-1.5 rounded-full bg-gray-400" />
//                             </div>

//                             {/* Horizontal Right Line segment */}
//                             <div className="w-6 h-0.5 bg-gray-300" />
//                           </div>
//                         )}
//                       </React.Fragment>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Slide-in Workflow Creation/Edit Form */}
//       {formState.open && (
//         <WorkflowForm 
//           workflow={formState.workflow} 
//           onSave={handleSave} 
//           onClose={() => setFormState({ open: false, workflow: null })} 
//         />
//       )}

//       {/* Delete Confirmation Offcanvas */}
//       <DeleteConfirmationOffcanvas 
//         isOpen={deleteState.open}
//         onClose={() => setDeleteState({ open: false, id: null, name: "" })}
//         onConfirm={handleDeleteConfirm}
//         title="Delete Appraisal Workflow"
//         itemName={deleteState.name}
//       />
//     </div>
//   );
// }




import React, { useState, useEffect, useCallback } from "react";
import { Plus, Edit, Trash2, GitFork, ArrowLeft, X, User, Users, AlertCircle } from "lucide-react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../helpers/PageLoader";
import SummaryApi from "../../../common/SummaryApi";
import api from "../../../common/apiClient";
import SelectDropdown from "../../../customStyles/SelectDropdown";
import DeleteConfirmationOffcanvas from "../../../helpers/DeleteConfirmationOffcanvas";

// Updated Evaluator types to match the backend enums
const EVALUATOR_TYPES = [
  { value: "SELF", label: "Self (Employee)" },
  { value: "REPORTING_MANAGER", label: "Reporting Manager (L1)" },
  { value: "SKIP_LEVEL_MANAGER", label: "Skip-Level Manager" },
  { value: "FUNCTIONAL_HEAD", label: "Functional Head (GM Level)" },
  { value: "SPECIFIC_USER", label: "Specific User" },
];

const emptyForm = {
  name: "",
  description: "",
  stages: [
    { sequence: 1, stageKey: "self", stageName: "Self Assessment", evaluatorType: "SELF", specificEvaluatorId: "" }
  ],
  isActive: true,
};

// Normalize dynamic mongoose populated objects to plain string IDs to resolve the Edit mode population bug
const normalizeWorkflowForEdit = (workflowToEdit) => {
  if (!workflowToEdit) return emptyForm;
  return {
    ...workflowToEdit,
    stages: (workflowToEdit.stages || []).map(stage => ({
      ...stage,
      // Extract the plain string ID from the populated user object
      specificEvaluatorId: stage.specificEvaluatorId?._id || stage.specificEvaluatorId || ""
    }))
  };
};

const WorkflowForm = ({ workflow, onSave, onClose }) => {
  const [form, setForm] = useState(() => normalizeWorkflowForEdit(workflow));
  const [users, setUsers] = useState([]);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchUsers = useCallback(async () => {
    try {
      const response = await api.get(SummaryApi.getAllUsers.url);
      if (response.data.success) {
        const activeUsers = (response.data.data || []).filter(
          (u) => u.isActive !== false,
        );

        const formatted = activeUsers.map((u) => ({
          label: `${u.firstName} ${u.lastName} (${u.customRoleId?.roleName || u.role})`,
          value: u._id,
        }));
        setUsers(formatted);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const updateSequencesAndKeys = (stagesList) => {
    return stagesList.map((stage, idx) => {
      const sequence = idx + 1;
      const stageKey = stage.stageName
        ? stage.stageName.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/(^_+|_+$)/g, "")
        : `stage_${sequence}`;

      return {
        ...stage,
        sequence,
        stageKey
      };
    });
  };

  const handleAddStage = () => {
    const newStageList = [
      ...form.stages,
      { sequence: form.stages.length + 1, stageKey: "", stageName: "", evaluatorType: "REPORTING_MANAGER", specificEvaluatorId: "" }
    ];
    setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(newStageList) }));
    setErrors({});
  };

  const handleRemoveStage = (index) => {
    if (form.stages.length <= 1) {
      return toast.error("At least one stage is required.");
    }
    const filteredList = form.stages.filter((_, idx) => idx !== index);
    setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(filteredList) }));
    setErrors({});
  };

// Locate handleStageChange function inside KRAReviewWorkflowManagement.jsx and replace it:

const handleStageChange = (index, key, val) => {
  const updatedList = form.stages.map((stage, idx) => {
    if (idx !== index) return stage;
    
    const updatedStage = { ...stage, [key]: val };
    
    // Auto-fill stageName dynamically based on selected evaluatorType
    if (key === "evaluatorType") {
      if (val === "SELF") {
        updatedStage.stageName = "Self Assessment";
      } else if (val === "REPORTING_MANAGER") {
        updatedStage.stageName = "Reporting Manager Review";
      } else if (val === "SKIP_LEVEL_MANAGER") {
        updatedStage.stageName = "Skip-Level Review";
      } else if (val === "FUNCTIONAL_HEAD") {
        updatedStage.stageName = "Functional Head Review";
      } else if (val === "SPECIFIC_USER") {
        updatedStage.stageName = "Specific Evaluator Review";
      }
      
      // Reset specific user reference if the type is changed from SPECIFIC_USER
      if (val !== "SPECIFIC_USER") {
        updatedStage.specificEvaluatorId = "";
      }
    }
    return updatedStage;
  });

  setForm(prev => ({ ...prev, stages: updateSequencesAndKeys(updatedList) }));
  setErrors({});
};

  const validateForm = () => {
    const newErrors = {};
    if (!form.name.trim()) {
      newErrors.name = "Workflow name is required.";
    }

    const stageErrors = [];
    form.stages.forEach((stage, idx) => {
      const currentStageErrors = {};
      if (!stage.stageName.trim()) {
        currentStageErrors.stageName = "Stage display name is required.";
      }
      if (stage.evaluatorType === "SPECIFIC_USER" && !stage.specificEvaluatorId) {
        currentStageErrors.specificEvaluatorId = "Please select a specific evaluator user.";
      }

      if (Object.keys(currentStageErrors).length > 0) {
        stageErrors[idx] = currentStageErrors;
      }
    });

    if (stageErrors.length > 0) {
      newErrors.stages = stageErrors;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return toast.error("Please fill all the required fields correctly.");
    }

    setSaving(true);
    try {
      const res = workflow?._id
        ? await api.put(SummaryApi.updateKRAReviewWorkflow.url(workflow._id), form)
        : await api.post(SummaryApi.craeteKRAReviewWorkflow.url, form);

      toast.success(`Workflow successfully ${workflow ? "updated" : "created"}`);
      onSave(res.data.data);
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to process performance workflow request");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] overflow-hidden">
      <div className="absolute inset-0 bg-black/40 transition-opacity" onClick={onClose} />
      
      <div className="absolute inset-y-0 right-0 max-w-full flex">
        <div className="w-screen max-w-lg bg-white shadow-2xl flex flex-col animate-slide-in">
          <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h2 className="font-bold text-gray-800 text-lg">
              {workflow ? "Edit Performance Workflow" : "Create Performance Workflow"}
            </h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
              <X className="w-5 h-5" text-gray-500="true" />
            </button>
          </div>

          <form id="workflow-form" onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6 space-y-6">
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1">
                Workflow Name *
              </label>
              <input 
                type="text" 
                value={form.name}
                onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))}
                placeholder="e.g., Tech Team 3-Stage Appraisal"
                className={`w-full border rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 ${
                  errors.name 
                    ? "border-red-500 focus:ring-red-200" 
                    : "border-gray-300 focus:ring-red-300"
                }`}
              />
              {errors.name && (
                <p className="text-[11px] text-primary font-medium mt-1 flex items-center gap-1">
                  <AlertCircle className="w-3 h-3" /> {errors.name}
                </p>
              )}
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1">
                Description
              </label>
              <textarea 
                value={form.description}
                onChange={(e) => setForm(p => ({ ...p, description: e.target.value }))}
                placeholder="Describe who uses this workflow or process sequence"
                rows={2}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-red-300 resize-none"
              />
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <label className="text-xs font-bold text-gray-700 uppercase tracking-wider">
                  Appraisal Evaluation Stages *
                </label>
                <button 
                  type="button" 
                  onClick={handleAddStage}
                  className="text-xs bg-red-50 text-primary hover:bg-red-100 px-3 py-1.5 rounded-lg font-bold border border-red-200 flex items-center gap-1 transition-colors"
                >
                  <Plus className="w-3.5 h-3.5" /> Add Stage
                </button>
              </div>

              <div className="space-y-4">
                {form.stages.map((stage, idx) => {
                  const stageError = errors.stages?.[idx] || {};

                  return (
                    <div key={idx} className="relative p-4 bg-gray-50 rounded-xl border border-gray-200 space-y-4">
                      <div className="flex justify-between items-center">
                        <span className="text-xs font-bold bg-red-100 text-red-700 px-2 py-0.5 rounded-md uppercase">
                          Stage #{stage.sequence}
                        </span>
                        {form.stages.length > 1 && (
                          <button 
                            type="button" 
                            onClick={() => handleRemoveStage(idx)}
                            className="text-xs text-red-500 hover:text-red-700 font-semibold"
                          >
                            Remove
                          </button>
                        )}
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div>
                          <label className="block text-[11px] font-medium text-gray-500 mb-1">Display Name *</label>
                          <input 
                            type="text" 
                            value={stage.stageName}
                            onChange={(e) => handleStageChange(idx, "stageName", e.target.value)}
                            placeholder="e.g., L1 Manager Review"
                            className={`w-full border rounded-lg px-3 py-1.5 text-sm outline-none focus:ring-2 ${
                              stageError.stageName 
                                ? "border-red-500 focus:ring-red-200" 
                                : "border-gray-300 focus:ring-red-200"
                            }`}
                          />
                          {stageError.stageName && (
                            <p className="text-[10px] text-primary font-medium mt-1 flex items-center gap-1">
                              <AlertCircle className="w-3 h-3" /> {stageError.stageName}
                            </p>
                          )}
                        </div>

                        <div>
                          <label className="block text-[11px] font-medium text-gray-500 mb-1">Evaluator Method *</label>
                          <SelectDropdown 
                            options={EVALUATOR_TYPES}
                            value={stage.evaluatorType}
                            onChange={(val) => handleStageChange(idx, "evaluatorType", val)}
                            placeholder="Select evaluators"
                            valueKey="value"
                            labelKey="label"
                            ChildClassName="h-[34px] border-gray-300"
                            zIndex={66}
                          />
                        </div>
                      </div>

                      {stage.evaluatorType === "SPECIFIC_USER" && (
                        <div className="pt-1 animate-fade-in">
                          <label className="block text-[11px] font-medium text-gray-500 mb-1">
                            Select Specific Evaluator User *
                          </label>
                          <SelectDropdown 
                            options={users}
                            value={stage.specificEvaluatorId}
                            onChange={(val) => handleStageChange(idx, "specificEvaluatorId", val)}
                            placeholder="Search and select employee..."
                            searchable={true}
                            valueKey="value"
                            labelKey="label"
                            error={!!stageError.specificEvaluatorId}
                            zIndex={66}
                            ChildClassName={`h-[34px] ${stageError.specificEvaluatorId ? "border-red-500" : "border-gray-300"}`}
                          />
                          {stageError.specificEvaluatorId && (
                            <p className="text-[10px] text-primary font-medium mt-1 flex items-center gap-1">
                              <AlertCircle className="w-3 h-3" /> {stageError.specificEvaluatorId}
                            </p>
                          )}
                        </div>
                      )}

                      <div className="text-[10px] text-gray-400 text-left">
                        Technical identifier: <span className="font-mono text-gray-600">{stage.stageKey || "auto_generated"}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100">
              <span className="text-sm font-medium text-gray-700">Workflow Active Status</span>
              <button 
                type="button"
                onClick={() => setForm(p => ({ ...p, isActive: !p.isActive }))}
                className={`relative inline-flex h-6 w-11 rounded-full transition-colors ${form.isActive ? "bg-primary" : "bg-gray-300"}`}
              >
                <span className={`inline-block h-4 w-4 mt-1 ml-1 rounded-full bg-white transition-transform ${form.isActive ? "translate-x-5" : "translate-x-0"}`} />
              </button>
            </div>
          </form>

          <div className="p-6 border-t bg-gray-50 flex gap-3">
            <button type="button" onClick={onClose} className="flex-1 bg-white border border-gray-300 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-100 transition-colors">
              Cancel
            </button>
            <button type="submit" form="workflow-form" disabled={saving}
              className="flex-1 bg-primary hover:bg-red-700 text-white py-2.5 rounded-lg text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-50 shadow-lg shadow-red-100"
            >
              {saving ? "Saving…" : (workflow ? "Update Workflow" : "Create Workflow")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function KRAReviewWorkflowManagement() {
  const navigate = useNavigate();
  const [workflows, setWorkflows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formState, setFormState] = useState({ open: false, workflow: null });
  const [deleteState, setDeleteState] = useState({ open: false, id: null, name: "" });

  const loadWorkflows = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(SummaryApi.getAllKRAReviewWorkflows.url);
      setWorkflows(res.data.data || []);
    } catch {
      toast.error("Failed to load appraisal workflows");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadWorkflows();
  }, [loadWorkflows]);

  const handleSave = (saved) => {
    setWorkflows(prev => 
      prev.find(w => w._id === saved._id)
        ? prev.map(w => (w._id === saved._id ? saved : w))
        : [saved, ...prev]
    );
    setFormState({ open: false, workflow: null });
  };

  const handleDeleteConfirm = async () => {
    try {
      await api.delete(SummaryApi.deleteKRAReviewWorkflow.url(deleteState.id));
      setWorkflows(prev => prev.filter(w => w._id !== deleteState.id));
      toast.success("Workflow removed successfully");
      setDeleteState({ open: false, id: null, name: "" });
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete workflow config");
    }
  };

  // Maps the evaluator types to readable labels dynamically (Added new types mapping)
  const getEvaluatorLabel = (stage) => {
    if (stage.evaluatorType === "SELF") return "Self Appraisal";
    if (stage.evaluatorType === "REPORTING_MANAGER") return "Reporting Manager (L1)";
    if (stage.evaluatorType === "SKIP_LEVEL_MANAGER") return "Skip-Level Manager"; // Mapped
    if (stage.evaluatorType === "FUNCTIONAL_HEAD") return "Functional Head (GM Level)"; // Mapped
    if (stage.evaluatorType === "SPECIFIC_USER" && stage.specificEvaluatorId) {
      const user = stage.specificEvaluatorId;
      const roleName = user.customRoleId?.roleName || user.role || "Employee";
      return `${user.firstName} ${user.lastName} (${roleName})`;
    }
    return "Not Configured";
  };

  const getThemeColors = (index) => {
    const themes = [
      { border: "border-[#fbc531]", text: "text-[#fbc531]", bg: "bg-[#fbc531]/5" }, 
      { border: "border-[#fa8231]", text: "text-[#fa8231]", bg: "bg-[#fa8231]/5" }, 
      { border: "border-[#ef57b2]", text: "text-[#ef57b2]", bg: "bg-[#ef57b2]/5" }, 
      { border: "border-[#2bcbba]", text: "text-[#2bcbba]", bg: "bg-[#2bcbba]/5" }, 
      { border: "border-[#a55eea]", text: "text-[#a55eea]", bg: "bg-[#a55eea]/5" }  
    ];
    return themes[index % themes.length];
  };

  return (
    <div className="p-4">
      <div className="mb-6 flex flex-row justify-between items-center gap-2">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="rounded-lg bg-red-50 border border-red-100 hover:border-red-500 text-primary p-2 transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2">
            <div className="p-1.5 bg-red-100 rounded-lg hidden xs:block">
              <GitFork className="w-5 h-5 text-primary" />
            </div>
            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 whitespace-nowrap tracking-tight">
              Appraisal Workflows
            </h1>
          </div>
        </div>
        <button 
          onClick={() => setFormState({ open: true, workflow: null })}
          className="flex items-center gap-2 bg-primary text-white p-2.5 sm:px-4 sm:py-2 rounded-lg hover:shadow-lg transition-all flex-shrink-0" // ✅ FIXED bg--primary to bg-primary
        >
          <Plus className="w-5 h-5" /> 
          <span className="hidden sm:block text-sm font-semibold">Add Workflow</span>
        </button>
      </div>

      {loading ? (
        <PageLoader />
      ) : workflows.length === 0 ? (
        <div className="text-center py-20 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
          <GitFork className="w-16 h-16 mx-auto mb-4 text-gray-300" />
          <p className="text-gray-500 font-medium">No performance appraisal workflows configured yet.</p>
          <button 
            onClick={() => setFormState({ open: true, workflow: null })} 
            className="mt-4 text-primary font-bold hover:underline"
          >
            Create your first workflow
          </button>
        </div>
      ) : (
        <div className="space-y-6">
          {workflows.map((flow) => (
            <div 
              key={flow._id} 
              className="bg-white border border-gray-100 shadow-sm rounded-xl p-6 hover:shadow-md transition-all flex flex-col gap-6"
            >
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-gray-100 pb-4 text-left">
                <div>
                  <div className="flex items-center gap-2.5 mb-1.5">
                    <span className="font-bold text-gray-900 text-base leading-tight">{flow.name}</span>
                    <span className={`px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider ${
                      flow.isActive 
                        ? "bg-green-50 text-green-700 border border-green-200" 
                        : "bg-gray-100 text-gray-500 border border-gray-200"
                    }`}>
                      {flow.isActive ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 leading-relaxed max-w-2xl">
                    {flow.description || "No description provided."}
                  </p>
                </div>
                
                <div className="flex gap-2 self-end sm:self-auto shrink-0">
                  <button 
                    onClick={() => setFormState({ open: true, workflow: flow })}
                    className="p-2 text-gray-400 hover:text-primary hover:bg-red-50 rounded-lg transition-all"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                  <button 
                    onClick={() => setDeleteState({ open: true, id: flow._id, name: flow.name })}
                    className="p-2 text-gray-400 hover:text-primary hover:bg-red-50 rounded-lg transition-all"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </div>
              </div>

              <div className="w-full overflow-x-auto py-4 px-1 custom-scrollbar">
                <div className="flex items-center min-w-max pr-6">
                  {flow.stages.map((stage, sIdx) => {
                    const colors = getThemeColors(sIdx);
                    
                    return (
                      <React.Fragment key={sIdx}>
                        <div className={`w-[220px] rounded-[12px] border-2 ${colors.border} ${colors.bg} p-5 relative flex flex-col justify-between items-center text-center shrink-0 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md`}>
                          
                          <div className="w-full">
                            <h4 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                              Stage {stage.sequence}
                            </h4>
                            <p className="text-sm font-extrabold text-gray-800 leading-snug px-1 truncate">
                              {stage.stageName}
                            </p>
                          </div>

                          <div className="w-4/5 my-4 border-t border-gray-200 flex justify-center items-center">
                            <span className="bg-white border-2 border-gray-300 rounded-full p-1.5 -mt-3.5 shadow-sm text-gray-500">
                              {stage.evaluatorType === "SELF" ? (
                                <User className="w-3.5 h-3.5" />
                              ) : (
                                <Users className="w-3.5 h-3.5" />
                              )}
                            </span>
                          </div>

                          <div className="w-full text-center">
                            <p className="text-xs font-semibold text-gray-600 px-1 truncate">
                              {getEvaluatorLabel(stage)}
                            </p>
                            <p className="text-[10px] text-gray-400 font-mono mt-1 tracking-wider uppercase">
                              {stage.evaluatorType.replace(/_/g, " ")}
                            </p>
                          </div>
                        </div>

                        {sIdx < flow.stages.length - 1 && (
                          <div className="flex items-center shrink-0">
                            <div className="w-6 h-0.5 bg-gray-300" />
                            
                            <div className="w-4 h-4 rounded-full border-2 border-gray-300 bg-white shadow-sm flex items-center justify-center shrink-0 relative z-10">
                              <div className="w-1.5 h-1.5 rounded-full bg-gray-400" />
                            </div>

                            <div className="w-6 h-0.5 bg-gray-300" />
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {formState.open && (
        <WorkflowForm 
          workflow={formState.workflow} 
          onSave={handleSave} 
          onClose={() => setFormState({ open: false, workflow: null })} 
        />
      )}

      <DeleteConfirmationOffcanvas 
        isOpen={deleteState.open}
        onClose={() => setDeleteState({ open: false, id: null, name: "" })}
        onConfirm={handleDeleteConfirm}
        title="Delete Appraisal Workflow"
        itemName={deleteState.name}
      />
    </div>
  );
}